import { FC, ReactElement } from 'react';
import { RouteProps } from 'react-router';
import PrivateRoute from './privateRoute';
import { useIntl } from 'react-intl';
import { Permission } from '@/interfaces/auth';

export interface WrapperRouteProps extends RouteProps {
  /** document title locale id */
  titleId: string;
  /** authorization？ */
  auth?: boolean;
  permissions?: Permission[];
}

const WrapperRouteComponent: FC<WrapperRouteProps> = ({ titleId, auth, permissions, ...props }) => {
  const { formatMessage } = useIntl();

  if (titleId) {
    document.title = formatMessage({
      id: titleId
    });
  }

  return auth || permissions ? <PrivateRoute permissions={permissions} {...props} /> : (props.element as ReactElement);
};

export default WrapperRouteComponent;
